import { RuntimeConfig } from '@/types/configuration.type';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

/**
 * Runtime tenant config endpoint (ADR-07). Same-origin, relative path — host is
 * the tenant, so no domain param and no `Cloud-Levvel-Tenant` header.
 * Live fetch is exercised at 联调; dev boots from the local mock instead.
 */
const configurationApi = createApi({
  reducerPath: 'configurationApi',
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: builder => ({
    getConfiguration: builder.query<RuntimeConfig, void>({
      query: () => ({
        url: '/api/v1/configuration',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetConfigurationQuery } = configurationApi;
export default configurationApi;
